// extracted by mini-css-extract-plugin
export const assetsAccountDetails = "TransactionEditForm__assetsAccountDetails__8vAix";
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "TransactionEditForm__body__EUv7v";
export const bold = "700";
export const buttonWrapper = "TransactionEditForm__buttonWrapper__2aYPW";
export const buttons = "TransactionEditForm__buttons__weAU7";
export const cancelButtonContent = "TransactionEditForm__cancelButtonContent__nYdD7";
export const cancelButtonWrapper = "TransactionEditForm__cancelButtonWrapper__DPBw5";
export const categoryField = "TransactionEditForm__categoryField__Md24t";
export const categoryFieldWrapper = "TransactionEditForm__categoryFieldWrapper__AYQ34";
export const categoryLabel = "TransactionEditForm__categoryLabel__sr3d0 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const cell = "TransactionEditForm__cell__Iby-N";
export const cellSimpleStyles = "TransactionEditForm__cellSimpleStyles__igV-D";
export const commandColumnContent = "TransactionEditForm__commandColumnContent__qrytg";
export const content = "TransactionEditForm__content__+8ef1";
export const creditAccountDetails = "TransactionEditForm__creditAccountDetails__suMXZ";
export const debtsAccountDetails = "TransactionEditForm__debtsAccountDetails__6etLd";
export const down = "TransactionEditForm__down__vBl3V";
export const editButtonWrapper = "TransactionEditForm__editButtonWrapper__kXk9P";
export const footer = "TransactionEditForm__footer__lD+D1";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headerCell = "TransactionEditForm__headerCell__g4ZNi";
export const headerRow = "TransactionEditForm__headerRow__KSYYN";
export const headerTitle = "TransactionEditForm__headerTitle__y02m6";
export const hidden = "TransactionEditForm__hidden__Ho8G-";
export const isMobile = "TransactionEditForm__isMobile__4ZYV5";
export const medium = "500";
export const pageSizeSelectorWrapper = "TransactionEditForm__pageSizeSelectorWrapper__5NgVA";
export const regular = "400";
export const row = "TransactionEditForm__row__RV++F";
export const rowField = "TransactionEditForm__rowField__LfmgA Table2__cell__Ab0yr";
export const rowFieldsTable = "TransactionEditForm__rowFieldsTable__nD5-i";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sortableHeaderCell = "TransactionEditForm__sortableHeaderCell__vRj6o";
export const sortingWrapper = "TransactionEditForm__sortingWrapper__I1CQT";
export const table = "TransactionEditForm__table__P9mLP";
export const tableContainer = "TransactionEditForm__tableContainer__QeLLX";
export const textCenter = "TransactionEditForm__textCenter__uI1sm";
export const textFieldWrapper = "TransactionEditForm__textFieldWrapper__6NkHc";
export const title = "TransactionEditForm__title__4dnvO font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const tooltipIconWrapper = "TransactionEditForm__tooltipIconWrapper__fl-RF";
export const transactionEditForm = "TransactionEditForm__transactionEditForm__UH1sU";
export const transactions = "TransactionEditForm__transactions__6Be92";
export const up = "TransactionEditForm__up__anPjQ";
export const white = "TransactionEditForm__white__BO7xW";
export const withHelpText = "TransactionEditForm__withHelpText__zeovu";